import * as React from 'react';
import { UIHeading2, UIText1 } from '@cian/ui-kit';
import cx from 'classnames';

import * as styles from './FormModalHeaderLayout.css';

interface IFormModalHeaderLayoutProps {
  title?: string;
  subtitle?: string;
}
export const FormModalHeaderLayout: React.FC<IFormModalHeaderLayoutProps> = ({ title, subtitle }) => {
  return (
    <div className={styles['header']}>
      <div className={cx(subtitle && styles['title'])}>
        <UIHeading2>{title}</UIHeading2>
      </div>
      {subtitle && <UIText1 color="gray60_100">{subtitle}</UIText1>}
    </div>
  );
};
